import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';
import { UserContext } from '../context/UserContext';
import { clearAuthState, getAuthToken } from '../utils/authStorage';

const PrivateRoute = ({ children }) => {
  const { userData, setUserData } = useContext(UserContext);

  // Token ellenőrzése a localStorage-ból (consistent key names)
  const token = userData?.token || getAuthToken();

  console.log("PrivateRoute ellenőrzés:", token);

  if (!token) {
    console.log("Nincs token, átirányítás a /login oldalra");
    return <Navigate to="/login" />;
  }

  if (userData?.requiresRoleSelection) {
    return <Navigate to="/choose-role" />;
  }

  try {
    // Token dekódolása a lejárati idő ellenőrzéséhez
    const decoded = jwtDecode(token);
    const tokenExpiration = decoded.exp * 1000; // Átalakítás milliszekundumra
    const isTokenExpired = Date.now() > tokenExpiration;

    if (isTokenExpired) {
      console.log("Token lejárt, átirányítás a /login oldalra");
      setUserData(null); // Felhasználói adatok törlése
      clearAuthState(); // Token és role törlése
      localStorage.removeItem('refresh_token'); // Refresh token törlése
      return <Navigate to="/login" />;
    }

    // Ha a token nem járt le, engedélyezzük a hozzáférést
    return children;

  } catch (error) {
    console.error("Hiba a token dekódolása során:", error);
    clearAuthState(); // Hibás token esetén töröljük
    localStorage.removeItem('refresh_token');
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
